import {
    Billing,
    BalanceDetails,
    SingleBillingDetails,
    ProfessionalBillingDetails,
} from 'one-state-billing-details';

import {format} from 'one-util-date'; 


export const TransformBillingDetails = (response: any, context: any) => {

    let billingdata: Billing[] = [];
    let billingresult: any = {
        billingdata: billingdata,
        error: undefined

    }
    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    log.debug("one-epic", "TransformBillingDetails transformation entered", response);
    if (response && (response.status >= 400 || response.type == "error")) {
        billingresult.error = response;
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            if (ele?.GuarantorAccounts?.length > 0) {
                ele.GuarantorAccounts.map((account: any) => {
                    let billing: Billing = {
                        serviceAreaName: "",
                        patientsGuarantor: false,
                        paperless: false,
                        AccountId: "",
                        AccountName: "",
                        balanceDetails: undefined,
                        singleBillingDetails: undefined,
                        professionalBillingDetails: undefined,
                        relation: account?.PatientIsGuarantor ? "Self" : "Other",
                    };

                    let balancelist: BalanceDetails[] = [];
                    let singlebillinglist: SingleBillingDetails[] = [];
                    let professionalbillinglist: ProfessionalBillingDetails[] = [];

                    billing.serviceAreaName = account?.ServiceArea?.Name;
                    billing.patientsGuarantor = account?.PatientIsGuarantor;
                    billing.paperless = account?.IsPaperless;
                    if (account?.AccountIDs) {
                        account.AccountIDs.map((element: any) => {
                            if (element?.Type === 'INTERNAL') {
                                billing.AccountId = element.ID;
                            }
                            if (element?.Type === 'NAME') {
                                billing.AccountName = element.ID;
                            }
                        })
                    }

                    if (account?.SingleBillingOffice?.OutstandingAccount) {
                        let totalPatientBalance = 0;
                        let totalInsuranceBalance = 0;
                        
                        if (account.SingleBillingOffice.OutstandingAccount.Accounts) {
                            account.SingleBillingOffice.OutstandingAccount.Accounts.forEach((sbo: any) => {
                                totalPatientBalance += sbo?.PatientBalance ? parseFloat(sbo.PatientBalance) : 0;
                                totalInsuranceBalance += sbo?.InsuranceBalance ? parseFloat(sbo.InsuranceBalance) : 0;
                            });
                        }

                        let sboobj: BalanceDetails = {
                            type: "SBO",
                            patientBalance: totalPatientBalance.toFixed(2),
                            insuranceBalance: totalInsuranceBalance.toFixed(2),
                        }
                        balancelist.push(sboobj);
                    }

                    // Handle Hospital and professional Billing Balance
                
                    if (account?.ProfessionalBilling?.TransactionSummary || account?.HospitalBilling?.OutstandingAccount) {
                        let pbhbobj: BalanceDetails = {
                            type: "PB/HB",
                            patientBalance: "",
                            insuranceBalance: "",
                        }
                        let patientbal: any = 0;
                        let insurancebal: any = 0;
                        // if (account.ProfessionalBilling?.TransactionSummary) {
                        //     patientbal = patientbal + (account.ProfessionalBilling.TransactionSummary.PatientBalance ?
                        //         parseFloat(account.ProfessionalBilling.TransactionSummary.PatientBalance) : 0);
                        //     insurancebal = insurancebal + (account.ProfessionalBilling.TransactionSummary.InsuranceBalance ?
                        //         parseFloat(account.ProfessionalBilling.TransactionSummary.InsuranceBalance) : 0);
                        // }
                          if (account.ProfessionalBilling?.TransactionSummary?.Patients) {
                            account.ProfessionalBilling.TransactionSummary.Patients.forEach((pat: any) => {
                            patientbal = patientbal + (pat?.PatientBalance ?
                                parseFloat(pat?.PatientBalance) : 0);
                            insurancebal = insurancebal + (pat?.InsuranceBalance ?
                                parseFloat(pat?.InsuranceBalance) : 0);
                        });
                        }
                        if (account.HospitalBilling?.OutstandingAccount?.Accounts) {
                            account.HospitalBilling.OutstandingAccount.Accounts.forEach((hbAccount: any) => {
                                patientbal = patientbal + (hbAccount?.PatientBalance ? parseFloat(hbAccount.PatientBalance) : 0);
                                insurancebal = insurancebal + (hbAccount?.InsuranceBalance ? parseFloat(hbAccount.InsuranceBalance) : 0);
                            });
                        }
                        pbhbobj.patientBalance = patientbal.toFixed(2);
                        pbhbobj.insuranceBalance = insurancebal.toFixed(2);
                        balancelist.push(pbhbobj);
                    }

                    if (account?.SingleBillingOffice?.OutstandingAccount?.Accounts) {
                        account.SingleBillingOffice.OutstandingAccount.Accounts.map((sbo: any) => {
                            let sboobj: SingleBillingDetails = {
                                admitdate: sbo?.AdmitDate ? format(sbo.AdmitDate,dateformat): "",
                                accountname: sbo?.HospitalAccountName,
                                locationname: sbo?.LocationName,
                                servicetype: sbo?.HospitalService ? 'Hospital' : (sbo?.ProfessionalService ? 'Professional' : ""),
                                patientbalance: sbo?.PatientBalance ? "$" + parseFloat(sbo.PatientBalance).toFixed(2) : "$0.00",
                                insurancebalance: sbo?.InsuranceBalance ? "$" + parseFloat(sbo.InsuranceBalance).toFixed(2) : "$0.00",
                            }
                            singlebillinglist.push(sboobj);
                        })
                    }

                    // Handle Hospital Billing Details
                    if (account?.HospitalBilling?.OutstandingAccount?.Accounts) {
                        account.HospitalBilling.OutstandingAccount.Accounts.map((hb: any) => {
                            let hbobj: ProfessionalBillingDetails = {
                                code: "",
                                date: hb?.AdmitDate ? format(hb.AdmitDate,dateformat) : "",
                                departmentname: hb?.LocationName,
                                description: Array.isArray(hb?.Description) ? hb.Description[0] : "",
                                providername: hb?.HospitalAccountName,
                                patientbalance: hb?.PatientBalance ? "$" + parseFloat(hb.PatientBalance).toFixed(2) : "$0.00",
                                insurancebalance: hb?.InsuranceBalance ? "$" + parseFloat(hb.InsuranceBalance).toFixed(2) : "$0.00",
                            }
                            professionalbillinglist.push(hbobj);
                        });
                    }

                    if (account?.ProfessionalBilling?.TransactionSummary?.Patients &&
                        account.ProfessionalBilling.TransactionSummary.Patients.length > 0) {
                        account.ProfessionalBilling.TransactionSummary.Patients.map((pat: any) => {
                            if (pat?.Visits &&
                                pat.Visits.length > 0) {
                                pat.Visits.map((visit: any) => {
                                    if (visit?.Charges &&
                                        visit.Charges.length > 0) {
                                        visit.Charges.map((pbhb: any) => {
                                            let phpbobj: ProfessionalBillingDetails = {
                                                code: pbhb?.Code,
                                                date: pbhb?.Date ? format(pbhb.Date,dateformat)  : "",
                                                departmentname: pbhb?.DepartmentName,
                                                description: pbhb?.Description,
                                                providername: pbhb?.ProviderName,
                                                patientbalance: pbhb?.PatientAmount ? "$" + parseFloat(pbhb.PatientAmount).toFixed(2) : "$0.00",
                                                insurancebalance: pbhb?.InsuranceAmount ? "$" + parseFloat(pbhb.InsuranceAmount).toFixed(2) : "$0.00",
                                            }
                                            professionalbillinglist.push(phpbobj);
                                        })
                                    }
                                })
                            }
                        })
                    }

                    billing.balanceDetails = balancelist;
                    billing.singleBillingDetails = singlebillinglist;
                    billing.professionalBillingDetails = professionalbillinglist;

                    billingdata.push(billing);
                })
            }
        });
    }
    billingresult.billingdata = billingdata;
    log.debug("one-epic", "TransformBillingDetails transformation Completed", billingresult);
    return billingresult;
}